import { render, staticRenderFns } from "./ProductTables.vue?vue&type=template&id=125499ff&"
import script from "./ProductTables.vue?vue&type=script&lang=js&"
export * from "./ProductTables.vue?vue&type=script&lang=js&"
import style0 from "./ProductTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports